// extracted by mini-css-extract-plugin
module.exports = {"color":"color__1U64Z","active":"active__3FYqB","disable":"disable__37Jfv"};